export default {"src":"/_next/static/media/legalOutline100_40.821be8b8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};